module.exports = __webpack_public_path__ + "img/Orca.61c409d5.svg";